import { useEffect, useState } from 'react'

import { usePlayerStore } from '../../../../services/store'
import { useGet } from '../../../../hooks/apiHooks'
import { config } from '../../../Init/Init'

export const useCryptoCurrencies = cryptoPaymentModalMode => {
  const [cryptoCurrencies, setCryptoCurrencies] = useState([])
  const [selectedCurrency, setSelectedCurrency] = useState(cryptoCurrencies[0] || { currencyCode: '', protocols: [] })

  const playerStore = usePlayerStore()
  const playerStatus = playerStore.use.status()

  const { GET, isLoading } = useGet()

  useEffect(() => {
    if (
      (playerStatus === config.status.partial || playerStatus === config.status.registered) &&
      cryptoPaymentModalMode &&
      cryptoCurrencies.length === 0
    ) {
      GET(`${config.paymentsUrl}${config.getCryptoCurrenciesUrl}`)
        .then(data => {
          if (data.currencies.length > 0) {
            setCryptoCurrencies(data.currencies)
          }
        })
        .catch(error => console.log(error))
    }
  }, [cryptoPaymentModalMode, playerStatus])

  return { cryptoCurrencies, isCryptoCurrenciesLoading: isLoading, selectedCurrency, setSelectedCurrency }
}
